<template>
  <div class="operate-container flex flex-col justify-center items-center">
    <div class="layout-padding w-full flex flex-col items-center relative">
      <div ref="titleElement" class="text-7xl z-20 title-animate" :class="{ 'animate-in': titleVisible }">
        {{ content.whereWeOperate }}
      </div>
      <div ref="subtitleElement" class="paragraph text-center home-operate-subtitle text-lg w-full mt-6 z-20 subtitle-animate"
        :class="{ 'animate-in': subtitleVisible }">
        {{ operate[0].subtitle }}
      </div>
      <button ref="buttonElement" class="z-20 readmore-button-animate" :class="{ 'animate-in': buttonVisible }"
        @click="gotoOperate">{{ content.readMore }}</button>

      <router-link ref="linkElement" to="/operate" class="z-20 link-animate inline-block"
        :class="{ 'animate-in': linkVisible }"
        style="color: black !important; background-color: red !important; padding: 8px 16px; text-decoration: none;">
        <div class="font-bold text-2xl mt-1">{{ content.readMore }}</div>
      </router-link>
      <div ref="yellowBoxElement" class="absolute w-60 h-40 bg-safetyYellow -top-2 left-1/2 yellow-box-animate"
        :class="{ 'animate-in': yellowBoxVisible }" style="z-index: 1;" hidden></div>
    </div>
    <Map />
  </div>
</template>

<script>
import Map from "/src/components/ui/Map.vue";

export default {
  props: ["operate"],
  inject: ["content"],
  components: {
    Map,
  },
  data() {
    return {
      titleVisible: false,
      subtitleVisible: false,
      linkVisible: false,
      yellowBoxVisible: false,
      observer: null,
      buttonVisible: false,
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    gotoOperate() {
      this.$router.push('/operate');
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px 0px -100px 0px",
        threshold: 0.1,
      };
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;

            // Add staggered delays for sequential animation
            if (element === this.$refs.titleElement) {
              setTimeout(() => {
                this.titleVisible = true;
              }, 100);
            } else if (element === this.$refs.subtitleElement) {
              setTimeout(() => {
                this.subtitleVisible = true;
              }, 300);
            } else if (element === this.$refs.linkElement) {
              setTimeout(() => {
                this.linkVisible = true;
              }, 500);
            } else if (element === this.$refs.yellowBoxElement) {
              setTimeout(() => {
                this.yellowBoxVisible = true;
              }, 200); // Yellow box animates early to appear behind text
            }
            else if (element === this.$refs.buttonElement) {
              setTimeout(() => {
                this.buttonVisible = true;
              }, 400);
            }
          }
        });
      }, options);
      this.observeElements();
    },

    observeElements() {
      this.$nextTick(() => {
        setTimeout(() => {
          const elementsToObserve = [
            this.$refs.titleElement,
            this.$refs.subtitleElement,
            this.$refs.linkElement,
            this.$refs.yellowBoxElement,
            this.$refs.buttonElement
          ];
          elementsToObserve.forEach(element => {
            if (element && element instanceof Element && this.observer) {
              this.observer.observe(element);
            }
          });
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
/* Base animation styles */
.title-animate,
.subtitle-animate,
.link-animate,
.yellow-box-animate {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Title animation */
.title-animate {
  transform: translateY(40px);
}

.title-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Subtitle animation */
.subtitle-animate {
  transform: translateY(20px);
}

.subtitle-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Link animation */
.link-animate {
  transform: translateY(15px);
}

.link-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Yellow box animation */
.yellow-box-animate {
  transform: scale(0.8) translateX(-50%);
  transform-origin: left center;
}

.yellow-box-animate.animate-in {
  opacity: 1;
  transform: scale(1) translateX(-50%);
}

/* Hover effects */
.link-animate:hover {
  transform: translateY(-2px);
  transition: transform 0.3s ease;
}
.readmore-button-animate {
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.6s ease;
}

.readmore-button-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}
</style>